import React, { useState } from 'react';
import Sidebar_Progress from "../../../layouts/Operational_Sidebar_Progress.component";
import customer from '../../../../img/customer-review.png'
import ReactDOM from 'react-dom';
import { API_URL } from "../../../../constant/API_Settings";
import swal from "sweetalert";
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import Modal from "react-modal";
import SummarySheet from '../SummarySheet.component';
import TabHeader from '../TabHeader.component';
import ClosePaymentModal from './ClosePaymentModal.component';
import LoginHeaderOperational from '../../LoginHeaderOperational';
import Loader from '../Loader.component'
import DeleteModalConfig from './DeleteModalConfig.component'
import PrintModalConfig from '../BagCollection/PrintModalConfig.component';
import PaginationComponent from '../../../layouts/PaginationComponent';
import moment from 'moment';

import { convertAmountToWords, preventNonNumericalInput, prevNonNumericalWithDec } from "../../../layouts/Operational_Sidebar_Progress.component";
import { applyCheckUrlNavigation } from '../../../../utils/checkUrlNavigation';
import { alignDenominationsWithMaster, amountOnEditLoad, applyDenominationCountChange, denominationMatchesAmount, denominationRowsForSave, resolvedFormAmount, sumDenominationAmount, uniqueDenominationNotes } from '../../../../utils/denominationRows';

function syncAmountWords(amount) {
	const amountEl = document.getElementById('amount');
	if (!amountEl) {
		return;
	}
	convertAmountToWords({ currentTarget: amountEl }, String(amount ?? ''));
}
const CloseModal = (props) => ReactDOM.createPortal(
	<ClosePaymentModal  {...props} />, document.body
);
const PaginationComp = (props) => (
	< PaginationComponent  {...props} />
);
const DeleteModal = (props) => ReactDOM.createPortal(
	<DeleteModalConfig  {...props} />, document.body
);
const PrintModal = (props) => ReactDOM.createPortal(
	<PrintModalConfig  {...props} />, document.body
);
const ClosePaymentConfig = (props) => {

	const [delete_id, deleteId] = useState([])
	const [inputValues, setInputValues] = useState({});
	const [input, setInput] = useState({});
	const [input1, setInput1] = useState({});
	const [input2, setInput2] = useState({});
	const [fields, setFields] = useState(['']);
	const history = useHistory()
	const [shift, setShit] = useState({});
	const [print_details, setPrint] = useState([])
	const [success, setSuccess] = useState([])
	const [total, setTotal] = useState([])
	const [search, setSearch] = useState('')
	const [summary, setSummary] = useState([])
	const [list_data, setList] = useState([])
	const [errors, setErrors] = useState({})
	const [denomination, setDenomination] = useState([])
	const [double, setDouble] = useState(true);
	const [denm, setDenm] = useState([])
	const [pages, setpages] = useState(
		{
			current_page: 1,
			last_page: 0,
			total_pages: 0,
			pagination_item: [],
			total_pages: 0,
		})
	//loader
	const [Loading, setLoading] = useState(false);
	//---On Load---//		
	useEffect(() => {
		check_url()


	}, []);
	function getSummerySheet() {
		const requestOptions = {
			method: 'post',
			body: JSON.stringify({
				op_emp_id: localStorage.getItem('op_emp_id'),
				emp_id: localStorage.getItem('emp_id'),
				op_date: localStorage.getItem('op_date'),
			}),

			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"

			},
		};
		fetch(API_URL + "/getSummerySheet", requestOptions)
			.then(response => { return response.json(); })
			.then(responseData => {
				setSummary(responseData)
				return responseData;
			})
			.catch(e => {
				console.log(e);

			});
	}
	//------------------------url
	function check_url() {
		const requestOptions = {
			method: 'post',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"
			},
			body: JSON.stringify({
				pathurl: window.location.pathname,
			}),
		};
		fetch(`${API_URL}/check_url`, requestOptions)
			.then(response => { return response.json(); })

			.then(responseData => {
				applyCheckUrlNavigation(history, responseData, window.location.pathname, () => {
					check_meta_date()
				});

				return responseData;
			})
			.catch(e => {
				console.log(e)
			});

	}
	function check_meta_date() {

		const requestOptions = {
			method: 'post',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"

			}
		};
		fetch(`${API_URL}/check_meta_date`, requestOptions)
			.then(response => { return response.json(); })
			.then(responseData => {
				//	console.log(responseData.op_date)
				if (!responseData.op_date || !localStorage.getItem('emp_id') || !localStorage.getItem('op_date')) {
					history.push("/nozzle-employee-list");
				}
				else {

					setInput1({ ...input1, op_date: responseData.op_date })
					ListClosingCash(pages.current_page)
				}

				return responseData;
			})
			.catch(e => {
				console.log(e)
			});

	}
	function ListClosingCash(page) {
		const requestOptions = {      //---employee listing---//
			method: 'get',
			// data: {
			// 	op_date:28/4/2018,
			// 	search_keyword:search
			// },
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"

			},
			// body: JSON.stringify({
			// 	op_date:28/4/2018,
			// 	search_keyword:search
			// })
		};
		fetch(`${API_URL}/bag-collection?search_keyword=${search}&page=${page}&list_item=cc&emp_id=${localStorage.getItem('emp_id')}&op_emp_id=${localStorage.getItem('op_emp_id')}&op_date=${localStorage.getItem('op_date')}`, requestOptions)
			.then(response => { return response.json(); })
			.then(responseData => {

				setList(responseData.data.data)
				setInput2({ ...input2, isdayclose: responseData.isdayclose })
				setShit({ ...shift, shift_time: responseData.shift_time })
				setLoading(true);

				setTotal({
					...total,
					totalamount: responseData.total_amount,
				})

				setLoading(true);

				setpages({
					...pages,
					current_page: responseData.data.current_page,
					last_page: responseData.data.last_page,
					per_pages: responseData.data.per_page,
					total_pages: responseData.data.total,

				})
				getSummerySheet();
				return responseData;
			})
			.catch(e => {
				console.log(e)

			});
	}
	function print_Closing(obj) {

		// deleteId(id)
		setPrint(obj)
		togglePrint()

	}
	function getDenomination() {
		const requestOptions = {
			method: 'get',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"
			},
		};
		fetch(API_URL + "/get-denomination", requestOptions)
			.then(response => { return response.json(); })
			.then(responseData => {
				const notes = uniqueDenominationNotes(
					Array.isArray(responseData.denomination) ? responseData.denomination : []
				);
				setDenm(notes.map((amount) => ({ amount })));
			})
			.catch(e => {
				console.log(e);

			});
	}


	const handlePagination = (number) => {
		setpages({
			...pages,
			current_page: number        //---pagination---//
		}
		)

		ListClosingCash(number)
	}
	//---Create popup function---//
	const UseModal = () => {

		const [isShowing, setIsShowing] = useState(false);

		function toggle(options = {}) {

			var isdayclose = input2.isdayclose;
			if (isdayclose == 1) {
				swal("", "You do not have this permission after day close", false ? "success" : "warning")
			}
			else {
				if (isShowing) {
					setInput({})
					setInputValues({})
					setDenm([])
					setErrors({})
					setSuccess({})
					setFields([''])
					setDenomination([])
				}
				if (!isShowing) {
					setDouble(true);
					setErrors({});
					if (!options.skipDenominationFetch) {
						setDenm([])
						getDenomination();
					}

				}
				setIsShowing(!isShowing);
			}
		}

		return {
			isShowing,
			toggle,
		}
	};
	const { isShowing, toggle } = UseModal();
	const UseDeleteModal = () => {

		const [isClose, setClose] = useState(false);

		function toggling() {

			setClose(!isClose);
		}

		return {
			isClose,
			toggling,
		}
	};
	const { isClose, toggling } = UseDeleteModal();
	//---Delete popup function---//
	const UsePrintModal = () => {

		const [isOpen, setOpen] = useState(false);

		function togglePrint() {

			setOpen(!isOpen);
		}

		return {
			isOpen,
			togglePrint,
		}
	};
	const { isOpen, togglePrint } = UsePrintModal();

	const handleInput = (e) => {
		setInput((prev) => ({
			...prev,
			[e.target.name]: e.target.value,
		}));
		convertAmountToWords(e, e.target.value)
	};

	const handleInputs = (e) => {
		setInput((prev) => ({
			...prev,
			[e.target.name]: e.target.value,
		}));
	}
	//---onchange functions---//
	function handleChange(event, idx) {
		const masterNotes = denm.length > 0 ? denm : denomination;
		const result = applyDenominationCountChange({
			masterNotes,
			savedRows: denomination,
			idx,
			countValue: event.target.value,
		});
		if (!result) {
			return;
		}

		const { aligned, amount } = result;
		setDenomination(aligned);
		// React state is the source of truth so the controlled Amount field updates immediately.
		setInput((prev) => ({
			...prev,
			denomination: aligned,
			amount,
		}));
		syncAmountWords(amount);
	}

	const handleSearch = (event) => {
		setSearch(event.target.value)
	}
	// ---handlesubmit function---//
	const handleSubmit = (event) => {
		event.preventDefault();
		setDouble(false);
		if (validateForm()) {
			sendClosingCash()
		}
	}
	//validations//

	function validateForm() {
		let errors = []
		let formIsValid = true
		const denominationTotal = sumDenominationAmount(denomination)
		const enteredAmount = resolvedFormAmount(
			input.amount || document.getElementById("amount")?.value,
			denomination
		)
		if (!enteredAmount) {
			formIsValid = false;
			setDouble(true)
			errors["amount"] = "Enter Amount"
		}
		else if (!denominationMatchesAmount(denominationTotal, enteredAmount)) {
			formIsValid = false;
			setDouble(true)
			errors["amount"] = "Denomination total must match rounded whole-rupee amount (paise ignored)"
		}
		else {
			errors["amount"] = ""
		}

		setErrors(errors)

		return formIsValid;


	}
	//---create closing cash---//
	function sendClosingCash() {

		const requestOptions = {
			method: 'POST',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"
			},

			body: JSON.stringify({

				note: input.note,
				amount: resolvedFormAmount(input.amount, denomination) || document.getElementById("amount")?.value,
				id: input.id,
				denomination: denominationRowsForSave(denomination),
				op_date: localStorage.getItem("op_date"),
				op_emp_id: localStorage.getItem('op_emp_id'),
				emp_id: localStorage.getItem('emp_id'),
				closing_cash: 1
			})
		};
		fetch(API_URL + "/bag-collection", requestOptions)
			.then(response => {
				return response.json();
			})
			.then(responseData => {

				setSuccess({
					...success,
					disabled: responseData.status === true ? true : false,
				})
				let errors = []
				if (responseData.status == false) {
					errors["amount"] = responseData.response.amount
					// errors["opening_balance"] = responseData.response.opening_balance
					// errors["phone"] = responseData.response.phone
					// errors["whatsapp_no"] = responseData.response.whatsapp_no
					setDouble(true);
				}
				if (responseData.status == 9) {
					swal("", responseData.message, responseData.status ? "warning" : "success")
					setDouble(true)
				}
				if (responseData.status == "DENY") {
					toggle();
					setDouble(true)
					swal("", responseData.message, responseData.status ? "warning" : "warning")
				}
				if (responseData.status == true) {
					swal("", responseData.message, responseData.status ? "success" : "warning")
					toggle();
					ListClosingCash(pages.current_page);
					setErrors([''])
					setDouble(true)
					setInputValues([])
					setDenomination([])
					setDenm([])

				}
				setErrors(errors)
				return responseData;
			})
			.catch(e => {
				swal("Something went wrong", "", "warning")
				console.log(e)
				setDouble(true)
			});
	}
	//---Edit employee list---//

	function edit_ClosingCash(id) {
		setErrors([])

		const requestOptions = {
			method: 'get',
			data: {
				id: id
			},
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"

			},
		};
		fetch(API_URL + "/bag-collection/" + id + "/edit", requestOptions)
			.then(response => { return response.json(); })
			.then(responseData => {
				const dens = alignDenominationsWithMaster(
					responseData.denomination || [],
					responseData.denomination || []
				);
				const nextAmount = amountOnEditLoad(dens, responseData.bag_collection?.amount);
				setInput({
					...responseData.bag_collection,
					amount: nextAmount,
				})
				setDenm(dens.map((row) => ({ amount: row.amount })))
				setDenomination(dens)
				toggle({ skipDenominationFetch: true });
				setTimeout(() => {
					syncAmountWords(nextAmount);
				}, 0);
				ListClosingCash(pages.current_page);
				return responseData;
			})
			.catch(e => {
				console.log(e)

			});
	}

	//---Delete EmployeeList---//	
	function delete_ClosingCash(id) {
		var isdayclose = input2.isdayclose;
		if (isdayclose == 1) {
			swal("", "You do not have this permission after day close", false ? "success" : "warning")
		}
		else {
			deleteId(id)

			toggling()
		}
	}

	function deleteClosingcash() {

		setDouble(false)
		const requestOptions = {
			method: 'DELETE',

			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"

			},
			body: JSON.stringify({
				delete_id: delete_id,
				closing_cash: 1
			})
		};
		fetch(API_URL + "/bag-collection/" + delete_id, requestOptions)
			.then(response => { return response.json(); })
			.then(responseData => {
				swal("", responseData.message, responseData.status ? "success" : "warning")
				ListClosingCash(pages.current_page);
				toggling()
				setDouble(true)
				return responseData;


			})

			.catch(err => {
				swal("Something went wrong", "", "warning")
				console.log(err)
			})
	}

	return (
		<>
			<div className="main-container page-wrap">
				<div className="d-md-flex">
					<Sidebar_Progress props={props} />
					<div className="content-area">
						<LoginHeaderOperational props={props} page_title="" />
						<div className="container pb-3 tab-view">
							<div className="row  mt-3 form-container">
								<div className="col-md-9">
									<TabHeader progress={9} />
									<div className="row">
										{Loading ? ListClosingCash :
											// <div class="loader text-primary">Loading...</div>
											<Loader />
										}
									</div>
									<div className="form-wrap ">

										<div className="tab-content" id="myTabContent">
											<div className="tab-pane fade show active" id="creditsales" role="tabpanel" aria-labelledby="creditsales-tab">
												<div className="">
													<div className="row mb-3">
														<div className="col-md">
															<div className="row">

																<div className="col-md col pl-0">
																	<h3 className="table-title">Closing Cash </h3><h4>({localStorage.getItem("emp_name")})-{moment(localStorage.getItem("op_date")).format("DD-MM-YYYY")}</h4>
																	{/*<h4 class="table-title">Shift Time : {localStorage.getItem("shift_time")} </h4>*/}
																</div>

															</div>
														</div>
														<div className="col-md-4">
															<a className="btn btn-primary px-3 mb-md-0 mb-2 " data-bs-target="#mla" onClick={toggle} >Add Closing Cash</a>
														</div>
														<div className="col-md-4">
															<div className="input-group mb-3 search">
																<span className="input-group-text" id="basic-addon1"><i className="fa fa-search" aria-hidden="true"></i>
																</span>
																<input type="text" className="form-control" placeholder="Search  " value={search.search_keyword} onChange={handleSearch} />
																<a className="btn btn-primary bt-search btn-sm" data-bs-target="#mla" onClick={check_url} >Submit</a>
															</div>
														</div>
													</div>


													<div className="table-widget">
														<table className="table border">
															<thead>
																<tr>


																	<th>Description</th>
																	<th >Amount</th>
																	<th>Operational Date</th>
																	<th>Action</th>

																</tr>
															</thead>
															<tbody>
																{
																	list_data.map(obj => (
																		<tr>
																			<td>{obj.note}</td>
																			<td>{obj.amount}</td>
																			<td>{moment(obj.op_date).format("DD-MM-YYYY")}</td>


																			<td class="py-2"><a href="#" class="text-secondary" onClick={() => edit_ClosingCash(obj.id)}><i class="fa fa-pencil-square-o pe-2" aria-hidden="true"></i></a>
																			{localStorage.getItem("save_hide") == 'false' ?
																				<a href="#" class="text-secondary" onClick={() => delete_ClosingCash(obj.id)}><i class="fa fa-trash-o pe-2" aria-hidden="true"></i></a>
																			:''}
																				<a href="#" class="text-secondary" onClick={() => print_Closing(obj)}>
																					<i class="fa fa-print" aria-hidden="true"></i>
																				</a>
																			</td>

																		</tr>
																	))}

																<tr>
																	<td colSpan={1} class="text-end mt-4"><b>Total Amount</b></td>
																	<td colSpan={4}>{total.totalamount} </td>
																</tr>
															</tbody>
														</table>
														{Loading ? <PaginationComp
															pages={pages}
															handlePagination={handlePagination}
														/> : ""
														}

													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-3">
									<SummarySheet summary={summary} />
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>

			{isShowing ? (<ClosePaymentModal
				isShowing={isShowing}
				hide={toggle}
				denm={denm}
				success={success}
				denomination={denomination}
				denominationTotal={sumDenominationAmount(denomination) || ''}
				handleInput={handleInput}
				handleInputs={handleInputs}
				preventNonNumericalInput={preventNonNumericalInput}
				prevNonNumericalWithDec={prevNonNumericalWithDec}
				inputValues={inputValues}
				fields={fields}
				handleChange={handleChange}
				handleSubmit={handleSubmit}
				double={double}
				input={input}
				// handleAdd={handleAdd}
				// handleRemove={handleRemove}
				errors={errors}
			/>) : null
			}
			{isClose ? (<DeleteModal
				isClose={isClose}
				hide={toggling}
				deleteClosingcash={deleteClosingcash}
				double={double}
			/>) : null
			}
			{isOpen ? (<PrintModal
				isOpen={isOpen}
				hide={togglePrint}
				print_details={print_details}
				shift={shift}


			/>) : null
			}

		</>
	)
}








export default ClosePaymentConfig